// Pre-recorded Lao voice clips played when STT fails or other voice events fire.
// Mirrors agxl-crop's systemAudio config — clips were generated upstream from
// Narakeet TTS and uploaded once to the voice-responses storage bucket.
//
// TODO (Phase 5): make language-aware. Storage already has _lo, _la, _km
// variants; a future helper should pick the right suffix from i18n.language
// (with fallback to _lo, since CBS Lao is the primary voice market today).
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://glyelurvdvrbqeyklseh.supabase.co';
const SYSTEM_AUDIO_BASE = `${SUPABASE_URL}/storage/v1/object/public/voice-responses/system`;

export const SYSTEM_AUDIO = {
  noSpeech: `${SYSTEM_AUDIO_BASE}/no_speech_lo.mp3`,
  pleaseRepeat: `${SYSTEM_AUDIO_BASE}/please_repeat_lo.mp3`,
  quotaExceeded: `${SYSTEM_AUDIO_BASE}/quota_exceeded_lo.mp3`,
  micDenied: `${SYSTEM_AUDIO_BASE}/mic_denied_lo.mp3`,
  offline: `${SYSTEM_AUDIO_BASE}/offline_lo.mp3`,
  genericError: `${SYSTEM_AUDIO_BASE}/generic_error_lo.mp3`,
  welcome: `${SYSTEM_AUDIO_BASE}/welcome_lo.mp3`,
  listening: `${SYSTEM_AUDIO_BASE}/listening_lo.mp3`,
} as const;

export function playSystemClip(clip: keyof typeof SYSTEM_AUDIO): void {
  const audio = new Audio(SYSTEM_AUDIO[clip]);
  audio.play().catch(e => console.warn(`System audio [${clip}] blocked:`, e));
}
